import { render, staticRenderFns } from "./Piutang.vue?vue&type=template&id=110f7f3f&"
import script from "./Piutang.vue?vue&type=script&lang=js&"
export * from "./Piutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports